import { useEffect, useRef } from "react";
import { createConsumer, Subscription } from "@rails/actioncable";

interface SubscriptionParams {
  channel: string;
  [key: string]: any;
}

interface UseActionCableOptions {
  onReceived?: (data: any) => void;
  onConnected?: () => void;
  onDisconnected?: () => void;
}

export function useActionCable(
  params: SubscriptionParams | null,
  options: UseActionCableOptions = {}
) {
  const subscriptionRef = useRef<Subscription | null>(null);
  const consumerRef = useRef(createConsumer());

  useEffect(() => {
    // Don't subscribe if params is null (for guest users)
    if (!params) {
      return;
    }

    const consumer = consumerRef.current;

    // Create subscription
    const subscription = consumer.subscriptions.create(params, {
      connected() {
        console.log(`Connected to ${params.channel}`);
        options.onConnected?.();
      },
      disconnected() {
        console.log(`Disconnected from ${params.channel}`);
        options.onDisconnected?.();
      },
      received(data: any) {
        console.log(`Received data from ${params.channel}:`, data);
        options.onReceived?.(data);
      },
    });

    subscriptionRef.current = subscription;

    // Cleanup on unmount
    return () => {
      if (subscriptionRef.current) {
        subscriptionRef.current.unsubscribe();
        subscriptionRef.current = null;
      }
    };
  }, [JSON.stringify(params)]); // Re-subscribe if params change

  return subscriptionRef.current;
}
